const CONTACT_GIN1_URL = process.env.REACT_APP_CONTACT_GIN1_URL || "http://localhost:8080";


async function ContactApiFetch(path, options = {}) {
    	const {
		method = "GET",
		body = null,
		headers = {},
	} = options;

    const normalizedPath = path.startsWith("/") ? path : `/${path}`;

    const requestHeaders = {
        "Content-Type": "application/json",
        ...headers,
    };

    const responde = await fetch(`${CONTACT_GIN1_URL}${normalizedPath}`, {
        method,
        headers: requestHeaders,
        ...(body ? { body: JSON.stringify(body) } : {}),
    });

    let payload = {};
    try {
        payload = await responde.json();
    } catch (error) {
        console.error("Error parsing JSON response:", error);
    }

    if (!responde.ok) {
        throw new Error(payload.message || "An error occurred while fetching data.");
    }

    return payload;
}


export async function sendContactForm(data) {
    return await ContactApiFetch("/inquiries/submit/", {
        method: "POST",
        body: data,
    });
}

